export const PARTNER_DEFAULT_FILTER = {
  name: undefined,
  enName: undefined,
  phone: undefined,
  address: undefined,
  buildingId: undefined,
};
